import React,{ useEffect } from 'react'
import StaffingSolutions from './StaffingSolutions';
import WhyPartner from './WhyPartner';
import "../assets/css/cxda.css";
import "aos/dist/aos.css";
import AOS from "aos";
import hero1 from "../assets/TIG Website Images/Our Businesses/HR Solutions/HR.png";
const Hrsolution = () => {
  return (
    <div>
       {/* Hero Section */}
      <div className="container-fluid p-0" >
        <div
          className="hero-section"
          style={{ backgroundImage: `url(${hero1})` }}
        >
          <div className="carousel-caption d-flex flex-column align-items-center justify-content-center text-center h-100">
            <div className="col-lg-10 zoom-in-text">
              <h1 className="display-4 fw-bold text-light mb-4 animated slideInDown">
             HR Solutions
              </h1>
            </div>
          </div>
        </div>
      </div>
        <WhyPartner/>
        <StaffingSolutions/>
    </div>
  )
}

export default Hrsolution